import { action, type Action } from 'easy-peasy';
import { CollapseType } from '@meitu/saas-editor-ui';

export interface IWatermarkCollapseModel {
    /**
     * 来源信息
     */
    from: CollapseType | null;

    /**
     * 设置来源信息
     */
    setFrom: Action<IWatermarkCollapseModel, CollapseType | null>;

    /**
     * 是否显示二级返回标题（进入专题列表需要展示二级返回标题）
     */
    showSubBackTitle: boolean;

    /**
     * 设置是否显示二级返回标题
     */
    setShowSubBackTitle: Action<IWatermarkCollapseModel, boolean>;
}

export const watermarkCollapseModel: IWatermarkCollapseModel = {
    from: null,

    setFrom: action((state, payload) => {
        state.from = payload;
    }),

    showSubBackTitle: false,

    setShowSubBackTitle: action((state, payload) => {
        state.showSubBackTitle = payload;
    }),
};
